import { useContext, useState } from 'react';
import { put } from './Api';
import * as Toast from './Toast.js';
import { ErrorContext } from './ErrorContext';
import type { APIErrorResponse, ApiOptions } from './Types';
import { AxiosError } from 'axios';

export default function (route: string, opts?: ApiOptions) {
    const [isUpdating, setIsUpdating] = useState(false);
    let res = null;
    const { errors, setErrors } = (res = useContext(ErrorContext));

    function update(id: number, updatedData: { [key: string]: any }) {
        if (isUpdating) {
            return Promise.resolve(null);
        }

        setIsUpdating(true);
        if (setErrors) setErrors(null); // Reset if we're posting again
        return put(`${route}/${id}`, updatedData)
            .catch((err: AxiosError<APIErrorResponse>) => {
                const message = err.response?.data?.message;
                if (!opts?.noToast) {
                    if (message) {
                        Toast.error(message);
                    } else {
                        Toast.error('Failed to update, please try again');
                    }
                }

                if (err.response?.data?.errors) {
                    if (setErrors) setErrors(err.response?.data?.errors);
                }

                throw err;
            })
            .finally(() => {
                setIsUpdating(false);
            });
    }

    return {
        isUpdating,
        update,
    };
}
